module.exports = "/images/display-popup.svg?2c09cc357f08b3a67c1ef948774237ed";